/**
 * SizilPro — / (index)
 * Redirects to the first active module or a welcome screen.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    // Default landing: proposals dashboard
    // When more modules exist, check subscriptions.modules[] to decide
    throw redirect({ to: "/proposal-builder" });
  },
  component: () => null,
});
